import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import { getaccount, accountmy } from "config";
import PropTypes from "prop-types";   // ✅ import PropTypes
import { myThings } from "config";

export const AccountsContext = createContext();

export const AccountsProvider = ({ children }) => {
  const [accounts, setAccounts] = useState({});
  const [loading, setLoading] = useState(false);
  const [things, setThings] = useState([]);
  const [orgName, setorgName] = useState([]);

  
  const handleAccount = async () => {
    const token = localStorage.getItem("token");
    setLoading(true);

    try {
      const response = await axios.get(accountmy, {
        headers: {
          "x-dhundhoo-session": token,
        },
      });

      const entities = response?.data.orgInfo?.entities || [];
      const orgName=response?.data.orgInfo?.orgName || "";
      
      if (entities.length) {
        await handleLoad(entities);
      }
      setorgName(orgName);
    } catch (error) {
      console.error("API Error in handleAccount:", error);
      setAccounts({});
    } finally {
      setLoading(false);
    }
  };

 
  const handleLoad = async (entities) => {
    const token = localStorage.getItem("token");
    setLoading(true);

    try {
      const response = await axios.post(
        getaccount,
        { accountIds: entities },
        {
          headers: {
            "x-dhundhoo-session": token,
          },
        }
      );

      setAccounts(response.data.accounts || {});
    } catch (error) {
      console.error("API Error in handleLoad:", error);
      setAccounts({});
    } finally {
      setLoading(false);
    }
  };

  const fetchThings = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(myThings,
        {
          headers: {
            "x-dhundhoo-session": token,
          },
        }
      );

      const data = response.data.orgThings;

      // Extract thingId & nickName
      const thingsArray = Object.values(data).map((item) => ({
        thingId: item.thing.thingId,
        nickName: item.thing.nickName,
      }));

      setThings(thingsArray);
    } catch (error) {
      console.error("Error fetching things:", error);
    }
  };
 
  return (
    
        <AccountsContext.Provider value={{ accounts,orgName, loading, handleAccount, handleLoad ,fetchThings,things}}>
          {children}
        </AccountsContext.Provider>
      );

};
AccountsProvider.propTypes = {
    children: PropTypes.node.isRequired,
  };



